const japanPrefectures = {
  hokkaido: 'Hokkaido',
  aomori: 'Aomori Prefecture',
  iwate: 'Iwate Prefecture',
  miyagi: 'Miyagi Prefecture',
  akita: 'Akita Prefecture',
  yamagata: 'Yamagata Prefecture',
  fukushima: 'Fukushima Prefecture',
  ibaraki: 'Ibaraki Prefecture',
  tochigi: 'Tochigi Prefecture',
  gunma: 'Gunma Prefecture',
  saitama: 'Saitama Prefecture',
  chiba: 'Chiba Prefecture',
  tokyo: 'Tokyo Metropolis',
  kanagawa: 'Kanagawa Prefecture',
  niigata: 'Niigata Prefecture',
  toyama: 'Toyama Prefecture',
  ishikawa: 'Ishikawa Prefecture',
  fukui: 'Fukui Prefecture',
  yamanashi: 'Yamanashi Prefecture',
  nagano: 'Nagano Prefecture',
  gifu: 'Gifu Prefecture',
  shizuoka: 'Shizuoka Prefecture',
  aichi: 'Aichi Prefecture',
  mie: 'Mie Prefecture',
  shiga: 'Shiga Prefecture',
  kyoto: 'Kyoto Prefecture',
  osaka: 'Osaka Prefecture',
  hyogo: 'Hyogo Prefecture',
  nara: 'Nara Prefecture',
  wakayama: 'Wakayama Prefecture',
  tottori: 'Tottori Prefecture',
  shimane: 'Shimane Prefecture',
  okayama: 'Okayama Prefecture',
  hiroshima: 'Hiroshima Prefecture',
  yamaguchi: 'Yamaguchi Prefecture',
  tokushima: 'Tokushima Prefecture',
  kagawa: 'Kagawa Prefecture',
  ehime: 'Ehime Prefecture',
  kochi: 'Kochi Prefecture',
  fukuoka: 'Fukuoka Prefecture',
  saga: 'Saga Prefecture',
  nagasaki: 'Nagasaki Prefecture',
  kumamoto: 'Kumamoto Prefecture',
  oita: 'Oita Prefecture',
  miyazaki: 'Miyazaki Prefecture',
  kagoshima: 'Kagoshima Prefecture',
  okinawa: 'Okinawa Prefecture'
};

export default japanPrefectures;
